<ng-container>
  <a
    (click)="itemClick($event)"
    [attr.aria-label]="item.label"
    [attr.tabindex]="0" [attr.target]="item.target"
    [ngClass]="item.class"
    [style.padding-left]="item.offset ? (item.offset * 3) + 'rem' : null"

    [routerLink]="item.routerLink"
    pRipple
    role="menuitem"
    routerLinkActive="active-menuitem-routerlink router-link-exact-active"
  >
    <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>

    <span class="text-nowrap">{{ item.label }}</span>
    <span><p-badge *ngIf="item.badge" [value]="item.badge" /></span>
    <i *ngIf="item.items" class="pi pi-fw {{active ? 'pi-angle-up' : 'pi-angle-down'}} ml-auto"></i>


  </a>
  <hr *ngIf="item.separator" class="menu-separator" style="margin: 0px"/>
</ng-container>
